import React from "react";
import { LANDING } from "../../constants/testIds";
import TypeformButton from "./TypeformButton";

export default function Navbar() {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-beige/80 backdrop-blur-md border-b border-chocolate/10 py-6 px-6 md:px-12 transition-luxury">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <div 
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="text-xl md:text-2xl font-editorial tracking-[0.15em] text-chocolate cursor-pointer"
          data-testid={LANDING.navbarLogo}
        >
          BACK TO YOU™
        </div>

        {/* Links */}
        <div className="hidden md:flex items-center space-x-10">
          <button 
            onClick={() => scrollToSection("il-problema")}
            className="text-sm font-medium tracking-wide text-chocolate/80 hover:text-bordeaux transition-colors"
          >
            IL PROBLEMA
          </button>
          <button 
            onClick={() => scrollToSection("metodo")}
            className="text-sm font-medium tracking-wide text-chocolate/80 hover:text-bordeaux transition-colors"
          >
            IL METODO
          </button>
          <button 
            onClick={() => scrollToSection("chi-sono")}
            className="text-sm font-medium tracking-wide text-chocolate/80 hover:text-bordeaux transition-colors"
          >
            CHI SONO
          </button>
          <button 
            onClick={() => scrollToSection("faq")}
            className="text-sm font-medium tracking-wide text-chocolate/80 hover:text-bordeaux transition-colors"
          >
            FAQ
          </button>
          <button 
            onClick={() => scrollToSection("community")}
            className="text-sm font-medium tracking-wide text-chocolate/80 hover:text-bordeaux transition-colors"
            data-testid={LANDING.navbarCommunityLink}
          >
            COMMUNITY
          </button>
        </div>

        {/* CTA */}
        <div className="flex items-center space-x-6">
          <TypeformButton
            className="bg-bordeaux text-white hover:bg-bordeaux-hover text-xs font-semibold tracking-widest px-6 py-3 rounded-none transition-luxury"
            testId={LANDING.navbarApplyBtn}
          >
            CANDIDATI ORA
          </TypeformButton>
        </div>
      </div>
    </nav>
  );
}
